import { render } from "./AddPanel.vue?vue&type=template&id=73f5ae7c"
import script from "./AddPanel.vue?vue&type=script&lang=js"
export * from "./AddPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__